var BASWebServices;
(function (BASWebServices) {
    'use strict';
    function filePreviewer($compile) {
        return {
            scope: "=",
            compile: function (tElement, tAttrs) {
                var divExtension = "";
                divExtension += '<span class="file-previewer ' + tAttrs.classestoset + '" data-ng-show="' + tAttrs.signalvariabletowatch + '" >';
                divExtension += '<span audio-player-im signalVariable="' + tAttrs.signalvariabletowatch + '">';
                divExtension += '</span>';
                divExtension += '</span>';
                divExtension += '<span class="file-previewer ' + tAttrs.classestoset + '" ng-show="' + tAttrs.textvariabletowatch + '">';
                divExtension += '<textarea class="textPreview" readonly>{{' + tAttrs.textvariabletowatch + '}}</textarea>';
                divExtension += '</span>';
                divExtension += '<span class="file-previewer ' + tAttrs.classestoset + '" ng-show="' + tAttrs.bpfvariabletowatch + '">';
                divExtension += '<textarea class="textPreview" readonly>{{' + tAttrs.bpfvariabletowatch + '}}</textarea>';
                divExtension += '</span>';
                var protocol = "http";
                if (tAttrs.resultfilelink != null && tAttrs.resultfilelink.lastIndexOf("https://") != -1) {
                    protocol = "https";
                }
                var linkToEmuWebappWParams = protocol + "://";
                linkToEmuWebappWParams += BASWebServices.ConfigService.GET_URL_EMU_WEBAPP();
                linkToEmuWebappWParams += "?audioGetUrl={{" + tAttrs.resultfilelink + " | WebappReplace | FilenameAnnotDeleteFilter | FilenameFilter }}.wav";
                linkToEmuWebappWParams += "&labelGetUrl={{" + tAttrs.resultfilelink + " | WebappReplace}}";
                linkToEmuWebappWParams += "&labelType={{" + tAttrs.resultfilelink + " | LabelTypeDetector}}";
                divExtension += '<span class="file-previewer ' + tAttrs.classestoset + '" ng-show="' + tAttrs.resultvariabletowatch + '">';
                divExtension += '  <div class="resultPreview">Result-Preview</div>';
                divExtension += '  <textarea class="textPreviewResult" readonly>{{' + tAttrs.resultvariabletowatch + '}}</textarea>';
                divExtension += '  <div class="downloadFile">';
                divExtension += '      <a class="downloadFileSub downloadFilelink" download="{{' + tAttrs.resultfilelink + '|UrlFilter}}" ng-href="{{' + tAttrs.resultfilelink + '}}">  Save result ';
                divExtension += '      <br/><br/><span data-ng-show="' + tAttrs.resultfilelink + '.lastIndexOf(\'TextGrid\')!=-1" class="imagePreviewer textgridLogo"></span>';
                divExtension += '      </a>';
                divExtension += '      <a class="emuLogo downloadFileSub imagePreviewer" ng-show="' + tAttrs.resultfilelink + '.lastIndexOf(\'TextGrid\')!=-1 || ' + tAttrs.resultfilelink + '.lastIndexOf(\'_annot.json\')!=-1 " href="' + linkToEmuWebappWParams + '" target="_blank"></a>';
                divExtension += '  </div>';
                divExtension += '  <div class="rightMargin">';
                divExtension += '  </div>';
                divExtension += '</span>';
                tElement.append(divExtension);
            }
        };
    }
    BASWebServices.filePreviewer = filePreviewer;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=filePreviewer.js.map